<template>
  <div class="product-list-container">
    <h1 class="page-title">商品列表</h1>
    <el-card class="content-card">
      <div class="card-header">
        <div class="search-area">
          <el-input
            v-model="searchForm.keyword"
            placeholder="搜索商品名称或描述"
            style="width: 300px; margin-right: 10px;"
            clearable
            prefix-icon="Search"
          >
          </el-input>
          <el-select 
            v-model="searchForm.category_id" 
            placeholder="选择分类"
            style="width: 200px; margin-right: 10px;"
          >
            <el-option label="全部分类" value="" />
            <el-option 
              v-for="category in categories" 
              :key="category.id" 
              :label="category.name" 
              :value="category.id"
            />
          </el-select>
          <el-select 
            v-model="searchForm.status" 
            placeholder="选择状态"
            style="width: 150px; margin-right: 10px;"
          >
            <el-option label="全部状态" value="" />
            <el-option label="启用" value="active" />
            <el-option label="禁用" value="inactive" />
          </el-select>
          <el-button type="primary" @click="handleSearch" icon="Search">搜索</el-button>
        </div>
        <el-button type="primary" @click="handleAdd">新增商品</el-button>
      </div>
      <div class="card-content">
        <el-table v-loading="tableLoading" :data="products" border stripe style="width: 100%">
          <el-table-column prop="name" label="商品名称" width="300" show-overflow-tooltip />
          <el-table-column label="查看规格" width="120" align="center">
            <template #default="scope">
              <el-button 
                v-if="scope.row.skulist && scope.row.skulist.length > 0"
                type="primary" 
                size="small" 
                @click="handleViewSpecs(scope.row)"
                plain
              >
                查看规格
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格" width="120" align="right">
            <template #default="scope">
              <span>¥{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="category.name" label="分类" width="180" />
          <el-table-column prop="sort_order" label="排序" width="150" align="center">
            <template #default="scope">
              <el-input-number
                v-model="scope.row.sort_order"
                :min="0"
                :step="1"
                :precision="0"
                @change="(value) => handleSortChange(scope.row.id, value)"
                size="small"
                style="width: 90px"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作"  fixed="right">
            <template #default="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope.row)">
                编辑
              </el-button>
              <el-button 
                type="danger" 
                size="small" 
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>
    
    <!-- 新增/编辑商品抽屉 -->
    <el-drawer
      v-model="dialogVisible"
      :title="isEdit ? '编辑商品' : '新增商品'"
      direction="rtl"
      size="80%"
    >
      <el-form :model="form" ref="formRef" label-width="120px">
        <el-form-item label="商品名称" required>
          <el-input v-model="form.name" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="商品简介">
          <el-input 
            v-model="form.intro" 
            placeholder="请输入商品简介" 
            type="textarea" 
            :rows="3"
          />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="价格" required>
              <el-input-number 
                v-model="form.price" 
                :min="0" 
                :step="0.01" 
                :precision="2"
                placeholder="请输入价格"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原价">
              <el-input-number 
                v-model="form.original_price" 
                :min="0" 
                :step="0.01" 
                :precision="2"
                placeholder="请输入原价"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input-number 
                v-model="form.sort_order" 
                :min="0" 
                :step="1"
                placeholder="请输入排序号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存">
              <el-input-number 
                v-model="form.stock" 
                :min="0" 
                :step="1"
                placeholder="请输入库存数量"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分类" required>
              <el-select v-model="form.category_id" placeholder="请选择分类" style="width: 100%;">
                <el-option 
                  v-for="category in categories" 
                  :key="category.id" 
                  :label="category.name" 
                  :value="category.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否在首页展示">
              <div style="display: flex; align-items: center;">
                <el-switch v-model="form.is_home_page" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品图片">
          <el-upload
            :file-list="imageFileList"
            :action="`${apiBaseUrl}/manage/upload/image`"
            list-type="picture-card"
            :auto-upload="true"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleImageUploadSuccess"
            :on-error="handleImageUploadError"
            :before-upload="beforeImageUpload"
            :data="{ type: 'product' }"
            :headers="{ 'Authorization': `Bearer ${authToken.value}` }"
          >
            <el-icon><plus /></el-icon>
            <template #tip>
              <div class="el-upload__tip">
                只能上传jpg/png文件，且不超过20MB
              </div>
            </template>
          </el-upload>
          <el-dialog v-model="previewVisible" title="预览图片">
            <img style="width: 100%" :src="dialogImageUrl" alt="预览图片" />
          </el-dialog>
        </el-form-item>
        
        <!-- 规格管理 -->
        <el-form-item label="商品规格">
          <div class="specs-container">
            <el-button type="primary" size="small" @click="handleAddSpec" style="margin-bottom: 10px;">
              新增规格
            </el-button>
            
            <div v-if="form.specs.length === 0" class="no-specs">
              暂无规格，点击"新增规格"按钮添加
            </div>
            
            <!-- 规格表头 -->
            <div v-if="form.specs.length > 0" class="spec-header">
              <span style="width: 150px; margin-right: 10px; display: inline-block; text-align: center;">SKU名称</span>
              <span style="width: 100px; margin-right: 10px; display: inline-block; text-align: center;">价格</span>
              <span style="width: 100px; margin-right: 10px; display: inline-block; text-align: center;">原始价格</span>
              <span style="width: 100px; margin-right: 10px; display: inline-block; text-align: center;">库存</span>
              <span style="width: 250px; margin-right: 10px; display: inline-block; text-align: center;">商品简介</span>
              <span style="width: 80px; display: inline-block; text-align: center;">操作</span>
            </div>
            
            <div v-for="(spec, index) in form.specs" :key="index" class="spec-item">
              <el-input 
                v-model="spec.sku_name" 
                placeholder="请输入SKU名称" 
                style="width: 150px; margin-right: 10px;"
              />
              <el-input-number 
                v-model="spec.price" 
                :min="0" 
                :step="0.01" 
                :precision="2"
                placeholder="请输入价格"
                style="width: 100px; margin-right: 10px;"
              />
              <el-input-number 
                v-model="spec.original_price" 
                :min="0" 
                :step="0.01" 
                :precision="2"
                placeholder="请输入原始价格"
                style="width: 100px; margin-right: 10px;"
              />
              <el-input-number 
                v-model="spec.stock" 
                :min="0" 
                :step="1"
                placeholder="请输入库存"
                style="width: 100px; margin-right: 10px;"
              />
              <el-input 
                v-model="spec.intro" 
                placeholder="请输入商品简介" 
                type="textarea" 
                :rows="2"
                style="width: 250px; margin-right: 10px; resize: none;"
              />
              <el-button 
                type="danger" 
                size="small" 
                @click="form.specs.splice(index, 1)"
              >
                删除
              </el-button>
            </div>
          </div>
        </el-form-item>
        
        <el-form-item label="商品描述">
          <div class="editor-container">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editorInstance"
              :default-config="editorConfig"
              :mode="'default'"
            />
            <Editor
              v-model="form.description"
              style="height: 300px; overflow-y: auto"
              :default-config="editorConfig"
              :mode="'default'"
              @onCreated="handleCreated"
              @onChange="handleChange"
            />
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-drawer>
    
    <!-- 查看规格对话框 -->
    <el-dialog
      v-model="specsDialogVisible"
      :title="`${currentProduct?.name || ''} - 规格列表`"
      width="80%"
    >
      <div class="specs-dialog-content">
        <el-table :data="currentSpecs" border stripe style="width: 100%">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="sku_name" label="SKU名称"  />
          <el-table-column prop="price" label="价格" width="100">
            <template #default="scope">
              <span>¥{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="original_price" label="原始价格" width="120">
            <template #default="scope">
              <span>¥{{ scope.row.original_price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" width="150" align="center">
            <template #default="scope">
              <el-input-number
                v-model="scope.row.stock"
                :min="0"
                :step="1"
                :precision="0"
                size="small"
                @change="(value) => handleStockChange(scope.row.id, value)"
                style="width: 120px"
              />
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template #default="scope">
              <el-tag :type="scope.row.status === 'active' ? 'success' : 'danger'">
                {{ scope.row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="specsDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, nextTick, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '../../api/axios';
// eslint-disable-next-line no-unused-vars
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
// 导入wangEditor样式
import '@wangeditor/editor/dist/css/style.css';

// 获取API基础URL，与axios配置保持一致
const apiBaseUrl = ref(process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000/api');


// 商品列表数据
const products = ref([]);
// 商品分类数据
const categories = ref([]);
// 对话框显示状态
const dialogVisible = ref(false);
// 规格对话框显示状态
const specsDialogVisible = ref(false);
// 表单引用
const formRef = ref();
// 是否为编辑模式
const isEdit = ref(false);
// 表格加载状态
const tableLoading = ref(false);

// 图片上传相关变量
const imageFileList = ref([]);
const previewVisible = ref(false);
const dialogImageUrl = ref('');

// 当前查看的商品规格
const currentProduct = ref(null);
const currentSpecs = ref([]);

// 搜索表单数据
const searchForm = reactive({
  keyword: '',
  category_id: '',
  status: ''
});

// 分页数据
const pagination = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0
});

// 表单数据
// eslint-disable-next-line no-unused-vars
const form = reactive({
  id: '',
  name: '',
  sku_name: '',
  intro: '',
  description: '',
  price: 0,
  original_price: 0,
  category_id: '',
  image: '',
  status: 'active',
  is_default: false,
  is_home_page: false,
  sort_order: 0,
  stock: 0,
  sold_count: 0,
  need_verification: false,
  support_shipping: false,
  goods_id: '',
  specs: []
});

// 获取token，处理localStorage不可用的情况
const getToken = () => {
  try {
    return localStorage.getItem('token') || '';
  } catch (e) {
    console.error('Failed to access localStorage:', e);
    return '';
  }
};

// 认证token
const authToken = ref(getToken());

// wangEditor配置
// eslint-disable-next-line no-unused-vars
const editorConfig = {
  placeholder: '请输入商品描述',
  // 使用默认工具栏，确保编辑器正常显示
  MENU_CONF: {
    uploadImage: {
      // 上传图片的接口地址
      server: `${apiBaseUrl}/manage/upload/image`,
      // 上传字段名
      fieldName: 'file',
      // 图片大小限制，单位KB
      maxFileSize: 20480, // 调整为20MB，更合理的大小限制
      // 自定义上传参数
      meta: {
        type: 'product' // 指定上传类型为商品
      },
      // 自定义请求头
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${authToken.value}` // 添加认证token
      },
      // 自定义上传图片，完全控制上传过程
      customUpload(file, insertFn) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'product');
        
        // 直接使用axios而不是全局request，避免响应拦截器影响
        // 因为图片上传返回的是errno格式，而全局request只处理code格式
        import('axios').then(axios => {
          axios.default({
            url: `${apiBaseUrl}/manage/upload/image`,
            method: 'post',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${authToken.value}`
            },
            timeout: 15000
          }).then(response => {
            // 直接获取response.data，不经过全局响应拦截器
            const res = response.data;
            // 处理上传成功的响应
            if (res.errno === 0 && res.data && res.data.length > 0) {
              let imgUrl = res.data[0].url;
              // 确保返回的是完整的图片URL
              if (imgUrl && !imgUrl.startsWith('http://') && !imgUrl.startsWith('https://')) {
                // 如果是相对路径，添加完整域名
                imgUrl = `${window.location.origin}${imgUrl}`;
              }
              // 使用insertFn插入图片，这是关键！
              insertFn(imgUrl, res.data[0].alt || file.name, imgUrl);
            } else {
              ElMessage.error('图片上传失败: ' + (res.message || '未知错误'));
            }
          }).catch(error => {
            console.error('上传失败', error);
            ElMessage.error('图片上传失败: ' + (error.message || '网络错误'));
          });
        });
      },
      // 上传失败后的回调
      onFailed(file, res) {
        console.error('上传失败', res);
        // 尝试从响应中获取错误信息
        let errorMessage = '未知错误';
        if (res) {
          if (res.message) {
            errorMessage = res.message;
          } else if (res.data && res.data.message) {
            errorMessage = res.data.message;
          } else if (res.errno !== undefined && res.errno !== 0) {
            errorMessage = res.data || '上传失败';
          }
        }
        ElMessage.error('图片上传失败: ' + errorMessage);
      }
    }
  }
};
// 编辑器实例，使用ref确保响应式更新
const editorInstance = ref(null);
// 编辑器内容
// eslint-disable-next-line no-unused-vars
const editorContent = ref('');

// 编辑器初始化完成时的回调
// eslint-disable-next-line no-unused-vars
const handleCreated = (editor) => {
  editorInstance.value = editor;
  // 设置初始内容
  editor.setHtml(form.description || '<p></p>');
};

// 编辑器内容变化时的回调
// eslint-disable-next-line no-unused-vars
const handleChange = (editor) => {
  form.description = editor.getHtml();
};

// 新增规格
// eslint-disable-next-line no-unused-vars
const handleAddSpec = () => {
  form.specs.push({
    sku_name: '',
    price: 0,
    original_price: 0,
    stock: 0,
    intro: ''
  });
};

// 监听dialogVisible变化，当抽屉打开时初始化编辑器
watch(
  () => dialogVisible.value,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        if (editorInstance.value) {
          editorInstance.value.setHtml(form.description || '<p></p>');
        }
      });
    }
  }
);

// 监听form.description变化，更新编辑器内容
watch(
  () => form.description,
  (newVal) => {
    if (editorInstance.value) {
      editorInstance.value.setHtml(newVal || '<p></p>');
    }
  }
);

// 监听dialogVisible变化，初始化图片文件列表
watch(
  () => dialogVisible.value,
  (newVal) => {
    if (newVal) {
      // 根据form.image初始化图片文件列表
      if (form.image) {
        imageFileList.value = [{
          url: form.image,
          name: form.image.split('/').pop(),
          uid: Date.now()
        }];
      } else {
        imageFileList.value = [];
      }
    }
  }
);

// 图片上传相关函数
// 预览图片
// eslint-disable-next-line no-unused-vars
const handlePictureCardPreview = (file) => {
  dialogImageUrl.value = file.url;
  previewVisible.value = true;
};

// 移除图片
// eslint-disable-next-line no-unused-vars
const handleRemove = () => {
  imageFileList.value = [];
  form.image = '';
};

// 图片上传前的验证
// eslint-disable-next-line no-unused-vars
const beforeImageUpload = (file) => {
  const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
  const isLt20M = file.size / 1024 / 1024 < 20;
  
  if (!isJPG) {
    ElMessage.error('只能上传JPG/PNG格式的图片');
  }
  if (!isLt20M) {
    ElMessage.error('图片大小不能超过20MB');
  }
  
  return isJPG && isLt20M;
};

// 图片上传成功回调
// eslint-disable-next-line no-unused-vars
const handleImageUploadSuccess = (response, file, fileList) => {
  // 处理后端返回的errno格式
  if (response.errno === 0) {
    // 确保返回的是完整的图片URL
    let imgUrl = response.data[0].url;
    // 检查URL是否是完整的http/https地址
    if (imgUrl && !imgUrl.startsWith('http://') && !imgUrl.startsWith('https://')) {
      // 如果是相对路径，添加完整域名
      imgUrl = `${window.location.origin}${imgUrl}`;
    }
    // 上传成功，设置商品图片URL
    form.image = imgUrl;
    // 更新文件列表，确保文件列表中的图片URL也是完整的
    const updatedFileList = fileList.map(item => {
      if (item.response && item.response.errno === 0 && item.response.data && item.response.data.length > 0) {
        let fileUrl = item.response.data[0].url;
        if (fileUrl && !fileUrl.startsWith('http://') && !fileUrl.startsWith('https://')) {
          fileUrl = `${window.location.origin}${fileUrl}`;
        }
        return {
          ...item,
          url: fileUrl
        };
      }
      return item;
    });
    imageFileList.value = updatedFileList;
    ElMessage.success('图片上传成功');
  } else {
    ElMessage.error('图片上传失败: ' + (response.message || '未知错误'));
  }
};

// 图片上传失败回调
// eslint-disable-next-line no-unused-vars
const handleImageUploadError = (error, file, fileList) => {
  // 尝试从error对象中获取错误信息，处理各种可能的error类型
  let errorMessage = '网络错误';
  if (error) {
    if (typeof error === 'string') {
      errorMessage = error;
    } else if (error.response && error.response.data) {
      // 处理axios错误对象
      errorMessage = error.response.data.message || '未知错误';
    } else if (error.message) {
      errorMessage = error.message;
    } else if (error.statusText) {
      errorMessage = error.statusText;
    }
  }
  ElMessage.error('图片上传失败: ' + errorMessage);
};

// 获取商品分类列表
const fetchCategories = async () => {
  try {
    const response = await request({
      url: '/manage/product-categories',
      method: 'get'
    });
    categories.value = response.data;
  } catch (error) {
    ElMessage.error('获取商品分类失败');
    console.error(error);
  }
};

// 获取商品列表
const fetchProducts = async () => {
  try {
    tableLoading.value = true;
    const response = await request({
      url: '/manage/products',
      method: 'get',
      params: {
        keyword: searchForm.keyword,
        category_id: searchForm.category_id,
        status: searchForm.status,
        page: pagination.currentPage,
        pageSize: pagination.pageSize
      }
    });
    
    // 调试：打印完整响应，查看实际数据结构
    console.log('商品列表响应:', response);
    
    // 简化数据解析，适应不同的后端返回格式
    let productData = [];
    let totalCount = 0;
    
    // 尝试多种数据解析路径
    if (response.data && response.data.data && Array.isArray(response.data.data.data)) {
      // 嵌套结构：response.data.data.data
      productData = response.data.data.data;
      totalCount = response.data.data.total || 0;
    } else if (response.data && Array.isArray(response.data.data)) {
      // 简化结构：response.data.data
      productData = response.data.data;
      totalCount = response.data.total || productData.length;
    } else if (Array.isArray(response.data)) {
      // 直接数组：response.data
      productData = response.data;
      totalCount = productData.length;
    }
    
    console.log('解析后的商品数据:', productData);
    console.log('总记录数:', totalCount);
    
    // 更新商品列表和分页数据
    products.value = productData;
    pagination.total = totalCount;
  } catch (error) {
    ElMessage.error('获取商品列表失败');
    console.error('获取商品列表错误:', error);
  } finally {
    tableLoading.value = false;
  }
};

// 页面加载时获取数据
onMounted(() => {
  fetchCategories();
  fetchProducts();
});

// 搜索商品
// eslint-disable-next-line no-unused-vars
const handleSearch = () => {
  pagination.currentPage = 1;
  fetchProducts();
};

// 分页大小变化
// eslint-disable-next-line no-unused-vars
const handleSizeChange = (size) => {
  pagination.pageSize = size;
  fetchProducts();
};

// 当前页码变化
// eslint-disable-next-line no-unused-vars
const handleCurrentChange = (current) => {
  pagination.currentPage = current;
  fetchProducts();
};

// 新增商品
// eslint-disable-next-line no-unused-vars
const handleAdd = () => {
  isEdit.value = false;
  // 重置表单
  Object.assign(form, {
    id: '',
    name: '',
    sku_name: '',
    intro: '',
    description: '',
    price: 0,
    original_price: 0,
    category_id: '',
    image: '',
    status: 'active',
    is_default: true, // 默认商品设置为true
    sort_order: 0,
    stock: 0,
    sold_count: 0,
    need_verification: false,
    support_shipping: false,
    goods_id: '',
    specs: []
  });
  dialogVisible.value = true;
};

// 编辑商品
// eslint-disable-next-line no-unused-vars
const handleEdit = async (row) => {
  isEdit.value = true;
  // 填充表单数据
  Object.assign(form, {
    id: row.id,
    name: row.name,
    sku_name: row.sku_name,
    intro: row.intro || '',
    description: row.description,
    price: row.price,
    original_price: row.original_price,
    category_id: row.category_id,
    image: row.image,
    status: row.status,
    is_default: row.is_default,
    is_home_page: false, // 默认设为false，然后检查实际状态
    sort_order: row.sort_order,
    stock: row.stock,
    sold_count: row.sold_count,
    need_verification: row.need_verification,
    support_shipping: row.support_shipping,
    goods_id: row.goods_id,
    specs: [] // 清空现有规格
  });
  
  // 使用skulist填充规格数据，排除主商品
  if (row.skulist && row.skulist.length > 0) {
    form.specs = row.skulist
      .filter(spec => spec.id !== row.id) // 排除主商品本身
      .map(spec => ({
        sku_name: spec.sku_name,
        price: spec.price,
        original_price: spec.original_price,
        stock: spec.stock,
        intro: spec.intro || ''
      }));
  }
  
  // 检查商品是否在首页展示
  try {
    const response = await request({
      url: `/manage/products/${row.id}/is-on-homepage`,
      method: 'get'
    });
    form.is_home_page = response.data.is_on_homepage;
  } catch (error) {
    console.error('检查商品首页展示状态失败:', error);
  }
  
  dialogVisible.value = true;
};

// 删除商品
// eslint-disable-next-line no-unused-vars
const handleDelete = (row) => {
  ElMessageBox.confirm('删除后将无法查看相关兑换记录，是否继续？', '删除确认', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      await request({
        url: `/manage/products/${row.id}`,
        method: 'delete'
      });
      ElMessage.success('删除商品成功');
      fetchProducts();
    } catch (error) {
      ElMessage.error('删除商品失败');
      console.error(error);
    }
  }).catch(() => {
    // 取消删除操作
  });
};

// 查看规格
// eslint-disable-next-line no-unused-vars
const handleViewSpecs = (row) => {
  currentProduct.value = row;
  currentSpecs.value = row.skulist || [];
  specsDialogVisible.value = true;
};

// 处理排序更改
// eslint-disable-next-line no-unused-vars
const handleSortChange = async (productId, newSortValue) => {
  try {
    await request({
      url: `/manage/products/${productId}`,
      method: 'put',
      data: {
        sort_order: newSortValue
      }
    });
    ElMessage.success('排序更新成功');
    // 重新获取商品列表，确保排序正确
    fetchProducts();
  } catch (error) {
    ElMessage.error('排序更新失败');
    console.error('排序更新失败:', error);
    // 重置排序值
    fetchProducts();
  }
};

// 处理库存更改
// eslint-disable-next-line no-unused-vars
const handleStockChange = async (productId, newStockValue) => {
  try {
    await request({
      url: `/manage/products/${productId}`,
      method: 'put',
      data: {
        stock: newStockValue
      }
    });
    ElMessage.success('库存更新成功');
    // 重新获取商品列表，确保库存数据正确
    fetchProducts();
  } catch (error) {
    ElMessage.error('库存更新失败');
    console.error('库存更新失败:', error);
    // 重置库存值
    fetchProducts();
  }
};

// 提交表单
// eslint-disable-next-line no-unused-vars
const handleSubmit = async () => {
  if (!formRef.value) return;
  
  try {
    let productId = form.id;
    
    if (isEdit.value) {
      // 更新商品
      await request({
        url: `/manage/products/${form.id}`,
        method: 'put',
        data: form
      });
      ElMessage.success('更新商品成功');
    } else {
      // 准备主商品数据
      const mainProductData = {
        name: form.name,
        sku_name: form.sku_name,
        intro: form.intro,
        description: form.description,
        price: form.price,
        original_price: form.original_price,
        category_id: form.category_id,
        image: form.image,
        status: form.status,
        sort_order: form.sort_order,
        stock: form.stock,
        sold_count: form.sold_count,
        need_verification: form.need_verification,
        support_shipping: form.support_shipping,
        is_default: true
      };
      
      // 准备规格商品数据
      const specProductsData = (form.specs || []).map(spec => ({
        sku_name: spec.sku_name,
        price: spec.price,
        original_price: spec.original_price,
        stock: spec.stock,
        intro: spec.intro
      }));
      
      // 使用批量创建API，将规格数据和主品一次传入
      const response = await request({
        url: '/manage/products/batch',
        method: 'post',
        data: {
          main_product: mainProductData,
          spec_products: specProductsData
        }
      });
      
      const result = response.data;
      productId = result.mainProduct.id;
      ElMessage.success('新增商品成功');
    }
    
    // 处理首页展示状态
    if (productId) {
      if (form.is_home_page) {
        // 添加到首页展示
        await request({
          url: `/manage/products/${productId}/add-to-homepage`,
          method: 'post'
        });
      } else {
        // 从首页展示移除
        await request({
          url: `/manage/products/${productId}/remove-from-homepage`,
          method: 'delete'
        });
      }
    }
    
    dialogVisible.value = false;
    fetchProducts();
  } catch (error) {
    ElMessage.error(isEdit.value ? '更新商品失败' : '新增商品失败');
    console.error(error);
  }
};
</script>

<style scoped>
.product-list-container {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.content-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.search-area {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.card-content {
  padding: 20px 0;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* wangEditor样式 */
.editor-container {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.w-e-text-container {
  max-height: 300px;
  overflow-y: auto;
}

/* 规格管理样式 */
.specs-container {
  padding: 10px 0;
}

.spec-header {
  font-weight: bold;
  padding: 10px;
  margin-bottom: 10px;
  border-bottom: 2px solid #e4e7ed;
  color: #303133;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.no-specs {
  color: #999;
  padding: 20px 0;
}

.spec-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  flex-wrap: wrap;
  gap: 10px;
}

.spec-item > * {
  margin-bottom: 10px;
}

/* 商品名称与查看规格按钮样式 */
.product-name-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.product-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}

.view-specs-btn {
  font-size: 12px;
}
</style>